/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/Delete/Content/Main/Content/DeleteAction/Content",
  onSubmit,
  isSubmitting
  
}) {
let deleteTreatmentCardSubmitData = fromData.useDataSubmit({ viewPath,
context: 'delete_treatment_card',
})
let deleteTreatmentCardIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'delete_treatment_card',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="delete_treatment_card"
 onClick={deleteTreatmentCardSubmitData}
 disabled={deleteTreatmentCardIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Delete"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}